import { render, staticRenderFns } from "./FirstName.vue?vue&type=template&id=0cc7062e"
import script from "./FirstName.vue?vue&type=script&lang=ts"
export * from "./FirstName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports